import 'jquery';
import AbstractController from './AbstractController';
import Controller from './Controller';
import { $window, $html, $body, Breakpoints } from '../constants';

// Utility
import HelperUtility from '../Utility/HelperUtility';

// Service
import HeadlineService from '../Service/HeadlineService';

// HtmlElements
import Banner from '../Elements/Banner';
import BannerCta from '../Elements/BannerCta';
import Header from '../Elements/Header';
import NavSubHorizontal from '../Elements/NavSubHorizontal';
import BackToTopButton from '../Elements/BackToTopButton';
import ContentSlider from '../Elements/ContentSlider';
import Videos from '../Elements/Videos';
import Form from '../Elements/Form';
import CtaBar from '../Elements/CtaBar';
import NavMain from '../Elements/NavMain';
import MetaBar from '../Elements/MetaBar';
import QuickSearch from '../Elements/QuickSearch';
import ShortcutsBar from '../Elements/ShortcutsBar';
import ProductSlider from '../Elements/ProductSlider';

/**
 * Controller for this page
 * Handles page flow and special HtmlElements
 *
 * @class
 */
class PageController extends AbstractController {

	/**
	 * @constructor
	 */
	constructor() {
		super();

		Controller.registerController(this);

		// Object containing special elements that inherit from HtmlElement
		// relevant page events are delegated to these objects through the controller
		this._registerElements(
			Banner,
			BannerCta,
			Header,
			NavSubHorizontal,
			BackToTopButton,
			...ContentSlider,
			...Videos,
			...Form,
			CtaBar,
			NavMain,
			MetaBar,
			QuickSearch,
			ShortcutsBar,
			...ProductSlider
		);

		// Initialize HeadlineService
		HeadlineService.initialize();
	}

	// Private

	/**
	 * Adds the javascript for accordions
	 *
	 * @return void
	 */
	_addAccordionJavascript() {
		$('[data-accordion]').each((i, el) => {
			let $accordion = $(el),
				$bigImageText = $accordion.parents('.big-image-text');

			if ($bigImageText.length > 0) {
				let $equalizedRow = $bigImageText.find('> .row'),
					$columns = $equalizedRow.find('> .columns[data-equalizer-watch]');

                $columns.each((i, el) => {
                    let $column = $(el),
                        equalizedHeight = $column.outerHeight();

                    $column.data('equalized-height', equalizedHeight);
                });

				$accordion.on('up.zf.accordion', () => {
                    $columns.each((i, el) => {
                        let $column = $(el);

                        $column.css({
							'height': $column.data('equalized-height'),
							'min-height': ''
                        });
                    });
				});

                $accordion.on('down.zf.accordion', () => {
                    $columns.each((i, el) => {
                        let $column = $(el);

                        $column.css({
                            'height': 'auto',
                            'min-height': $column.data('equalized-height')
                        });
                    });
                });

                $accordion.find('.accordion-title').on('click', () => {
                    $columns.each((i, el) => {
                    	let $column = $(el),
							equalizedHeight = $column.data('equalized-height');

                    	$column.css('min-height', '');

                    	if (equalizedHeight > 0) {
                    		$column.css({
								'height': 'auto',
								'min-height': equalizedHeight
							});
						}
					});
                });
			}

			/* $accordion.on('down.zf.accordion', () => {
				const $equalizer = $accordion.find('[data-equalizer]');

				$equalizer.each(function() {
					new Foundation.Equalizer($(this)).applyHeight();
				});
			}); */
		});
	}

	/**
	 * Adds the anchor scrolling functionality
	 *
	 * @return void
	 */
	_addAnchorScrolling() {
		$body.find('[href*="#"]').each((i, el) => {
			let $element = $(el),
				anchor = $element.get(0).hash;

			if (anchor.length > 1) {
				let $elementToScrollTo = $(anchor);

				if ($elementToScrollTo.length === 1) {
					$element.on('click', (e) => {
						e.preventDefault();
						this._scrollToElement($elementToScrollTo);
					});
				}
			}
		});
	}

	/**
	 * Scrolls the viewport to the given element
	 *
	 * @param { jQuery } $element
	 * @return void
	 */
	_scrollToElement($element) {
		let offset = $element.offset().top;

		if ($window.width() >= Breakpoints.LARGE) {
			offset = offset - Header.getHeight();

			if (NavSubHorizontal.exists()) {
				offset = offset - NavSubHorizontal.getHeight();
			}
		}

		$('html, body').animate({
			scrollTop: offset
		});
	}

	/**
	 * Scrolls automatically to the anchor of the current URL if given and valid
	 *
	 * @return void
	 */
	_scrollToCurrentAnchor() {
		let anchor = window.location.hash;

		if (anchor) {
			let $elementToScrollTo = $(anchor);
			if ($elementToScrollTo.length === 1) {
				$('html, body').animate({
					scrollTop: 0
				}, 0);

				this._scrollToElement($elementToScrollTo);
			}
		}
	}

	// Public

	/**
	 * Handles ready event
	 *
	 * @return void
	 */
	onReady() {
		super.onReady();

		$html.attr('data-touch-device', HelperUtility.isTouchDevice());

		if (!HelperUtility.supportsCssFilter()) {
			$html.addClass('no-css-filter');
		}

		this._addAccordionJavascript();
		this._addAnchorScrolling();
	}

	/**
	 * Handles load event
	 *
	 * @return void
	 */
	onLoad() {
		this._scrollToCurrentAnchor();
	}

	/**
	 * Checks if equalized rows contain boxes
	 *
	 * @return void
	 */
	checkRowsContainsBox() {
		let $rows = $('.row.equalized');

		$rows.each((i, el) => {
			let $row = $(el),
				$columns = $row.find('> .columns');

			$columns.each((i, el) => {
				let $box = $(el).find('.box');

				if ($box.length) {
					$row.addClass('contains-box');
				}
			});
		});
	}
}

export default (new PageController);
